import icons from 'url:../../img/icons.svg'; //Parcel 2

export default class View {
  _data;

  // jsdoc.app

  /**
   * Render the received object to the DOM
   * @param {Object | Object[]} data The data to be rendered (e.g. recipe)
   * @param {boolean} [render=true] If false, create markup string instead of rendering to the DOM
   * @returns {undefined | string} A markup string is returned if render=false
   * @this {Object} View instance
   * @author Patrick Wells
   * @todo Finish implementation
   */
  render(data, render = true) {
    if (!data || (Array.isArray(data) && data.length === 0))
      return this.renderError();

    this._data = data;
    const markup = this._generateMarkup();

    if (!render) return markup;

    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  update(data) {
    // if (!data || (Array.isArray(data) && data.length === 0))
    //   return this.renderError();

    // View's data becomes new data
    this._data = data;

    // newMarkup will just be a string and difficult to compare to DOM elements on the page
    const newMarkup = this._generateMarkup();

    // ***** converts newMarkup string into a DOM object that lives in the memory and can be used to compare with the DOM that's on the page ******
    const newDOM = document.createRange().createContextualFragment(newMarkup);

    // selecting all the new elements in the "virtual" DOM. then converting the nodelist into an array
    const newElements = Array.from(newDOM.querySelectorAll('*'));

    // selecting all the elements in the current DOM
    const curElements = Array.from(this._parentElement.querySelectorAll('*'));

    // all the elements in the current DOM
    // console.log(curElements);

    // all the elements in the newDOM object
    // console.log(newElements);

    // will compare the elements and only update ones that differ
    newElements.forEach((newEl, i) => {
      const curEl = curElements[i];

      // Updates chnaged TEXT
      if (
        !newEl.isEqualNode(curEl) &&
        newEl.firstChild?.nodeValue.trim() !== ''
      ) {
        // console.log('🍕', newEl.firstChild.nodeValue.trim());
        curEl.textContent = newEl.textContent;
      }

      // Updates changed ATTRIBUTES
      if (!newEl.isEqualNode(curEl)) {
        Array.from(newEl.attributes).forEach(attr =>
          curEl.setAttribute(attr.name, attr.value)
        );
      }
    });
  }

  _clear() {
    this._parentElement.innerHTML = '';
  }

  renderSpinner() {
    const markup = `
    <div class="spinner">
      <svg>
        <use href="${icons}#icon-loader"></use>
      </svg>
    </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderError(message = this._errorMessage) {
    const markup = `
      <div class="error">
        <div>
          <svg>
            <use href="${icons}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderMessage(message = this._message) {
    const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }
}
